import {Injectable} from '@angular/core';
import {TranslateService as Ng2TranslateService} from 'ng2-translate';
import {Observable} from 'rxjs/Observable';

let debug, debugOff = function (...any) {};
process.env.NODE_ENV !== 'production' && (debug = require('debug')('app:TranslateService'));

/**
 * Handles translation strings
 */
@Injectable()
export class TranslateService {

    constructor(
        private _ng2TranslateService: Ng2TranslateService
    ) {
        // 'Construct translate service' );

        // Config translation
        this._setupTranslation();
    }

    instant (key: string | Array<string>, interpolateParams?: Object): string | Array<string> {
        return this._ng2TranslateService.instant(key, interpolateParams);
    }

    get (key: string | Array<string>, interpolateParams?: Object): Observable<string | Array<string>> {
        return this._ng2TranslateService.get(key, interpolateParams);
    }

    /**
     * Configures params used for translation of strings in templates
     */
    private _setupTranslation() {
        this._ng2TranslateService.addLangs(['en', 'de']);
        this._ng2TranslateService.setDefaultLang('en');
        //let browserLang = this._ng2TranslateService.getBrowserLang();
        //this._ng2TranslateService.use(browserLang.match(/en|de/) ? browserLang : 'en');
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/shared/services/translate-service.ts